import validator from 'validator'

import {userAddressRetrieve, userAddressUpdate} from '../../api'

const addressApiStore = {
  state: {
    addressIndex: 0,
    line1: '',
    line2: '',
    city: '',
    state: '',
    zip: '',
    lastModified: 0
  },
  getters: {
    address: state => {
      return state
    },
    addressIndex: state => {
      return state.addressIndex
    },
    addressLastModified: state => {
      let timestamp = new Date(state.lastModifiedDate)
      return timestamp.toString()
    },
    line1: state => {
      return state.line1
    },
    line2: state => {
      return state.line2
    },
    city: state => {
      return state.city
    },
    state: state => {
      return state.state
    },
    zip: state => {
      return state.zip
    },
    line1Valid: (state, getters) => {
      return getters.line1.length > 0
    },
    line2Valid: (state, getters) => {
      // not required, no validation right now?
      return true
    },
    cityValid: (state, getters) => {
      return getters.city.length > 0
    },
    stateValid: (state, getters) => {
      return getters.state.length > 0
    },
    zipValid: (state, getters) => {
      const zip = getters.zip
      return zip.length > 0 &&
              validator.matches(zip, getters.zipRegex)
    },
    addressInputValid: (state, getters) => {
      return getters.line1Valid &&
              getters.line2Valid &&
              getters.cityValid &&
              getters.stateValid &&
              getters.zipValid
    }
  },
  mutations: {
    updateAddressIndex (state, addressIndex) {
      state.addressIndex = addressIndex
    },
    updateAddress1 (state, line1) {
      state.line1 = line1 || ''
    },
    updateAddress2 (state, line2) {
      state.line2 = line2 || ''
    },
    updateCity (state, city) {
      state.city = city || ''
    },
    updateState (state, province) {
      state.state = province || ''
    },
    updateZip (state, zip) {
      state.zip = zip || ''
    },
    updateAddressLastModified (state, lastModified) {
      // TODO do we need to check the type provided for a Date vs a unix timestamp?
      state.lastModified = lastModified
    }
  },
  actions: {
    /**
     * Update the address
     */
    updateAddressState (context, addressInfo) {
      context.commit('updateAddressIndex', addressInfo.addressIndex)
      context.commit('updateAddress1', addressInfo.line1)
      context.commit('updateAddress2', addressInfo.line2)
      context.commit('updateCity', addressInfo.city)
      context.commit('updateState', addressInfo.state)
      context.commit('updateZip', addressInfo.zip)
      context.commit('updateAddressLastModified', addressInfo.lastModified)
    },
    /**
     * User address retrieve API Method
     */
    userAddressRetrieve (context) {
      const apiClient = context.getters.apiClient
      const userId = context.getters.userId
      const addressIndex = context.getters.addressIndex

      return userAddressRetrieve(apiClient, userId, addressIndex)
        .then((addressInfo) => {
          context.dispatch('updateAddressState', addressInfo)
          console.log('Retrieved address data: %j', addressInfo)
          return addressInfo
        })
        .catch((error) => {
          // TODO track the error message somewhere?
          throw error
        })
    },
    /**
     * Send updated address details
     */
    userAddressUpdate (context) {
      const apiClient = context.getters.apiClient
      const addressInfo = context.getters.address
      const userId = context.getters.userId

      return userAddressUpdate(apiClient, userId, addressInfo)
        .then((addressInfo) => {
          context.dispatch('updateAddressState', addressInfo)
          console.log('Retrieved address data: %j', addressInfo)
          return addressInfo
        })
        .catch((error) => {
          // TODO track the error message somewhere?
          throw error
        })
    }
  }
}

export default addressApiStore



// WEBPACK FOOTER //
// ./src/store/app/address.js